module.exports = __webpack_public_path__ + "static/media/wait_3.7652d648.gif";